import Image from 'next/image';
import P from '../ui/P';
import { cn } from '@/lib/utils';
import Link from '../ui/Link';
import H6 from '../ui/H6';

export interface INewsCard {
    imageSrc: string;
    title: string;
    text: string;
    link: string;
    className?: string;
}

export default function NewsCard({ imageSrc, title, text, link, className }: INewsCard) {
    return (
        <Link
            className={cn(
                'flex flex-col relative group/card w-full max-lg:max-w-full max-xs:max-w-[220px] lg:max-w-[440px] max-lg:gap-5 lg:gap-10',
                className,
            )}
            href={link}
        >
            <>
                <div className="relative w-full max-xs:h-[200px] max-lg:h-[235px] lg:h-[333px] bg-tofu overflow-hidden">
                    <Image
                        className="group-hover/card:scale-110 group-hover/card:brightness-75 transition-all duration-300 object-cover object-center"
                        src={imageSrc}
                        alt="Blog Article"
                        fill
                    />
                </div>
                <div className="flex flex-col gap-5">
                    <H6>{title}</H6>
                    <hr className="h-[1px] border-black/50 w-full" />
                    <P className="max-w-[350px]">{text}</P>
                </div>
            </>
        </Link>
    );
}
